// extracted by mini-css-extract-plugin
module.exports = {"wholeBanner":"partner-banner_wholeBanner__BUy5e","titleTextContainer":"partner-banner_titleTextContainer__m9xMf","bannerText":"partner-banner_bannerText__YxVEp"};